// src/_newprofiles/components/ui/Button.jsx
import React from "react"
import PropTypes from "prop-types"

const Button = React.forwardRef(({ 
  className = "", 
  variant = "primary", 
  size = "default", 
  children, 
  ...props 
}, ref) => {
  let buttonClass = "btn"

  // Variant
  if (variant === "outline") buttonClass += " btn-outline"
  else if (variant === "ghost") buttonClass += " btn-ghost"
  else buttonClass += " btn-primary"

  // Size
  if (size === "sm") buttonClass += " btn-sm"

  // Extra
  if (className) buttonClass += " " + className

  return (
    <button ref={ref} className={buttonClass} {...props}>
      {children}
    </button>
  )
})

Button.displayName = "Button"

// (optional) runtime prop-type checks
Button.propTypes = {
  variant: PropTypes.oneOf(["primary","outline","ghost"]),
  size: PropTypes.oneOf(["default","sm"]),
  className: PropTypes.string,
  children: PropTypes.node,
}

export { Button }